/**
 *  @class
 *  @function SlideShowCustom
 */
if (!customElements.get('slideshow-custom')) {
    class SlideShowCustom extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }


        init() {
            if (this._flkty) return;
            const slideshow = this;

            let slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
                pageDots = false,
                selectedIndex = 0,
                prev_button = slideshow.querySelector('.flickity-prev'),
                next_button = slideshow.querySelector('.flickity-next');            

            let options = {
                wrapAround: false,
                contain: true,
                cellAlign: 'left',
                groupCells: true,
                pageDots: false,
                autoPlay: false,
                rightToLeft: false,
                prevNextButtons: false,
                cellSelector: '.carousel__slide',
                on: {}
            };


            // Early return guard
            if (slideshow_slides.length < 1) return;

            // enable dot navigation buttons at max-width: 767px            
            if ( matchMedia('screen and (max-width: 767px)').matches ) {
                options.pageDots = true;
                options.groupCells = '60%';
            }

            window.addEventListener('resize', (event) => {
                flkty.resize;
                if ( matchMedia('screen and (max-width: 767px)').matches ) {
                    options.pageDots = true;
                    options.groupCells = true;
                } else {
                    options.pageDots = false;
                    options.groupCells = true;
                }
            });
            

            // Initiate
            const flkty = new Flickity(slideshow, options);

            selectedIndex = flkty.selectedIndex;

            // Store Flickity instance for cleanup
            this._flkty = flkty;

            console.log("SLIDE LENGTH", flkty.slides.length);

            // Arrows
            if(flkty.slides.length == 1) {
                prev_button.classList.add('hide-arrow');
                next_button.classList.add('hide-arrow');
            } else {
                if (prev_button) {
                        prev_button.addEventListener('click', () => {
                        flkty.previous();
                    });
                        prev_button.addEventListener('keyup', () => {
                        flkty.previous();
                    });
                        next_button.addEventListener('click', () => {
                        flkty.next();
                    });
                    next_button.addEventListener('keyup', () => {
                        flkty.next();
                    });

                        // Hide arrows at scroll ends for non-wrapping carousels
                    if (!options.wrapAround) {
                        prev_button.classList.add('disabled');
                        flkty.on('change', function( event, index)  {
                            //console.log("SELECTED INDEX", flkty.selectedIndex);
                            if(flkty.selectedIndex < (flkty.slides.length - 1)) {
                                prev_button.classList.add('disabled');
                                next_button.classList.remove('disabled');
                            }

                            if(flkty.selectedIndex >= (flkty.slides.length - 1)) {
                                next_button.classList.add('disabled');
                                prev_button.classList.remove('disabled');
                            }                           
                        });
                    }
                }
            }            

            // Theme editor
            if (Shopify.designMode) {
                slideshow.addEventListener('shopify:block:select', (event) => {
                let index = slideshow_slides.indexOf(event.target);
                flkty.select(index);
                });
            }
        }


        disconnectedCallback() {
            // Destroy Flickity instance
            if (this._flkty) {
                this._flkty.destroy();
                this._flkty = null;
            }
            // Remove window resize listener
            if (this._resizeHandler) {
                window.removeEventListener('resize.center_arrows', this._resizeHandler);
                this._resizeHandler = null;
            }
        }
    }
    customElements.define('slideshow-custom', SlideShowCustom);
}

